import { configure } from "mobx";
import { RootStore } from "./RootStore";
// Side-effect import: registra los custom error processors del proyecto.
import "../api/customErrorProcessors";

function initMobX() {
  configure({ enforceActions: "observed" });
}

let _rootStore: RootStore | null = null;

export function getRootStore(): RootStore {
  if (!_rootStore) {
    initMobX();
    _rootStore = new RootStore();
  }
  return _rootStore;
}

export function initApp() {
  return getRootStore();
}
